import axios from "axios";
import { useEffect, useState } from "react";


const Api = axios.create({
    baseURL: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api/v1/`,
    // baseURL: `https://challenge.empoweru.io/api/v1/`
});

export default Api;